import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useCustomFieldPageContext } from '../../CustomFieldPageContext'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'

export function useRemove() {
  const { remove } = useCustomFieldPageContext()
  const options: RemoveRowActionOptions<ProjectCustomField> = {
    permission: Permission.RemoveRestoreCustomField,
    onRemove: ({ id }) => {
      remove.fn({ variables: { id } })
    },
  }
  return options
}
